$(document).on("hidden.bs.modal", ".cookie-settings-modal", e => $(this).remove());
